module.exports = __webpack_public_path__ + "img/operate-hover.675ed4da.png";